<template>
  <component :is="currentComponent" />
</template>
<style>
img {
  user-select: none; 
}
</style>
<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { defineAsyncComponent } from "vue";

const currentComponent = ref(null);

const isMobileDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  // 手机端关键字
  const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/;

  // 平板端关键字（iPad、Android Tablet）
  const tabletRegex = /ipad|tablet/;

  if (tabletRegex.test(userAgent)) {
    return false; // 平板按 PC 处理
  }

  return mobileRegex.test(userAgent);
};

const setComponent = () => {
  const isMobile = isMobileDevice();
  const isSmallScreen = window.innerWidth <= 768; // 小屏幕兜底逻辑

  if (isMobile || (isSmallScreen && !/ipad|tablet/i.test(navigator.userAgent))) {
    // 移动端 或 非平板的小屏幕设备
    currentComponent.value = defineAsyncComponent(() => import("./main2.vue"));
  } else {
    // PC 端 + 平板端
    currentComponent.value = defineAsyncComponent(() => import("./main.vue"));
  }
};

onMounted(() => {
  setComponent();
  window.addEventListener("resize", setComponent);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", setComponent);
});
</script>
